export const WHATSAPP_SUPPORT_URL = "https://wa.me/573242952314";

export type Tutorial = {
  id: string;
  title: string;
  description: string;
  embedUrl: string;
};

export const MAIN_TUTORIALS: Tutorial[] = [
  {
    id: "admin-1",
    title: "Portal Administrativo — Parte 1",
    description:
      "Empieza aquí. En este video conocerás la estructura general del Portal Administrativo: cómo navegar, dónde está cada módulo y cómo configurar tu cuenta desde cero.",
    embedUrl: "https://www.loom.com/embed/a0642f9c4aef46fba285e746c4293a41",
  },
  {
    id: "admin-2",
    title: "Portal Administrativo — Parte 2",
    description:
      "En esta segunda parte profundizamos en el corazón operativo del portal: el módulo de conciliación bancaria y la gestión de lotes de pagos. Aprenderás a cruzar los pagos recibidos contra los extractos de tu cuenta, revisar el estado de cada transferencia y cerrar tu proceso de recaudo sin depender de hojas de cálculo ni procesos manuales.",
    embedUrl: "https://www.loom.com/embed/282278a54ae44f91bc78ea39b01f1927",
  },
  {
    id: "payments-portal",
    title: "Portal de Pagos",
    description:
      "Este es el portal que verán tus arrendatarios. Aprende cómo funciona desde su perspectiva, cómo se ve el flujo de pago y qué experiencia ofrece en cada medio de pago disponible.",
    embedUrl: "https://www.loom.com/embed/a9c3963b8c0047d288bfcfc08bb21818",
  },
];

export const PROCESS_TUTORIALS: Tutorial[] = [
  {
    id: "bulk-upload",
    title: "Cómo subir recaudos de forma masiva",
    description: "Carga recaudos en lote con archivos desde el portal.",
    embedUrl:
      "https://drive.google.com/file/d/1Lqpq-6_kt0fYaP4NdR3eXs-QDfFSLdmL/preview",
  },
  {
    id: "manual-payments",
    title: "Cómo agregar recaudos de forma manual",
    description: "Registra recaudos uno a uno directamente desde Palomma.",
    embedUrl:
      "https://drive.google.com/file/d/1muj4weKIkXNxWlSRVBBd3wh0XoZD0zFT/preview",
  },
];
